import React, { memo } from 'react';

import { useSelector } from 'react-redux';

import { JiraIssueLink } from 'src/components/jira/jira-issue-link/jira-issue-link';
import { LoadingStatus } from 'src/constants/loading-status';
import {
  getPullRequestJiraIssuesFetchedStatus,
  getPullRequestJiraIssuesForComment,
} from 'src/redux/jira/selectors/jira-issue-selectors';
import { PrCommentJiraIssue } from 'src/redux/jira/types';
import { BucketState } from 'src/types/state';

import * as styles from './jira-issues.styled';

type Props = {
  commentId: number;
};

/* eslint @typescript-eslint/ban-types: "warn" */
export const JiraIssues: React.FC<Props> = memo(({ commentId }) => {
  const fetchedStatus = useSelector<BucketState, LoadingStatus>(
    getPullRequestJiraIssuesFetchedStatus
  );
  const issues = useSelector<BucketState, PrCommentJiraIssue[]>(state =>
    getPullRequestJiraIssuesForComment(state, commentId)
  );

  if (fetchedStatus === LoadingStatus.Success && issues.length > 0) {
    const uiEvent = {
      action: 'clicked',
      actionSubject: 'link',
      actionSubjectId: 'prJiraIssue',
      source: 'pullRequestComment',
    };
    return (
      <styles.JiraIssueWrapper>
        {issues.map(issue => (
          <styles.JiraIssueInnerWrapper
            key={`${issue.issue.id}-${issue.issue.project.id}`}
          >
            <JiraIssueLink
              jiraIssue={issue.issue}
              jiraUrl={issue.issue.site.cloudUrl}
              uiEvent={uiEvent}
            />
          </styles.JiraIssueInnerWrapper>
        ))}
      </styles.JiraIssueWrapper>
    );
  } else {
    return null;
  }
});
